import { AppointmentsService } from "../../../services/appointments/appointments.service";
import {
	TableTemplateButtons,
	TableTemplateButtonsEvent,
} from "../../components/table/table-template.model";
import {
	Appointment,
	AppointmentCoach,
	AppointmentTypes,
} from "./../../entities/appointments.model";
import { AppointmentRow } from "./appointments.model";

export type UpcomingAppointment = Omit<
	AppointmentRow,
	| "name"
	| "kannactId"
	| "coachId"
	| "phone"
	| "typeTemplate"
	| "kannactIdTemplate"
	| "phoneTemplate"
> & { entity: Appointment };

export class UpcomingAppointmentRow implements UpcomingAppointment {
	id: string;
	type: string;
	datetime: string; // Date
	duration: string;
	calendar: string;
	actionsTemplate: TableTemplateButtons;
	entity: Appointment;

	constructor(
		params: Appointment,
		appointmentTypes: AppointmentTypes[],
		appointmentCoaches: AppointmentCoach[],
		rescheduleFn: (e: TableTemplateButtonsEvent) => void,
		cancelFn: (e: TableTemplateButtonsEvent) => void
	) {
		this.id = params.id;
		this.type = params.type;
		this.datetime = AppointmentsService.templateDatetime(params.datetime)!;
		this.duration = AppointmentsService.templateDuration(params.type, appointmentTypes);
		this.calendar =
			AppointmentsService.getAppointmentCoach(appointmentCoaches, params.coachId)?.name ?? "";
		this.actionsTemplate = AppointmentsService.templateActions(rescheduleFn, cancelFn);
		this.entity = params;
	}
}
